import { useTranslation } from 'react-i18next';
import images from '../../../assets';
import { constantStrings } from '../../../constantStrings';
import { EmptyStateWrapper } from './styles';
import { EmptyStateProps } from './types';

const EmptyState = ({
    title = constantStrings.noDataFound,
    message = constantStrings.noDataMessage,
    className = 'arcadis-empty-state'
}: EmptyStateProps) => {
    const { t } = useTranslation();
    return (
        <EmptyStateWrapper className={className}>
            <img
                src={images['emptyStateIcon']}
                className='empty-state-icon'
                alt='Empty state icon'
            />
            <h5>{t(title)}</h5>
            <p>{t(message)}</p>
        </EmptyStateWrapper>
    );
};

EmptyState.defaultProps = {
    title: 'No Data Found',
    message: 'It looks like there’s nothing here yet.',
    className: 'arcadis-empty-state'
};

export default EmptyState;
